import { Swiper, Navigation, Set } from "swiper/swiper.esm.js";

export default class ExhibitsListing {
  constructor(exhibitsSlider) {
    Swiper.use([Navigation]);

    let sliderContainer = exhibitsSlider.parentElement;
    let prevButton = sliderContainer.querySelector(".swiper-button-prev");
    let nextButton = sliderContainer.querySelector(".swiper-button-next");

    var mySwiper = new Swiper(exhibitsSlider, {
      // Optional parameters

      speed: 1000,
      grabCursor: true,
      setWrapperSize: true,

      // Navigation arrows
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },

        768: {
          slidesPerView: 2,
          spaceBetween: 20,
          grabCursor: false,
        },

        980: {
          slidesPerView: 3,
          spaceBetween: 20,
          grabCursor: false,
        },
      },
    });
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const exhibitsSliders = document.querySelectorAll(
    '.js-exhibits-slider'
  );
  if (exhibitsSliders.length > 0) {
    exhibitsSliders.forEach((slider) => {
      new ExhibitsListing(slider);
    });
  }
});
